export function getInitials(name: string): string {
    const normalized = name.trim().replace(/\s+/g, " ");
    if (!normalized) {
        return "";
    }

    const tokens = normalized.split(" ");
    if (tokens.length >= 2) {
        return `${tokens[0][0]}${tokens[tokens.length - 1][0]}`.toUpperCase();
    }

    const word = tokens[0];
    if (word.length === 1) {
        return word.toUpperCase();
    }

    return word.slice(0, 2).toUpperCase();
}
